export default "__VITE_ASSET__c26d36a1__"